export const statements = {
  _title: 'Statements',
  create: 'Créer les statements',
  createAll: 'Créer les statements pour tous les ayants-droits',
  createdAll: 'Les statements ont été créés',
  createSummary: 'Télécharger le récapitulatif par ayant-droit',
  createdSummary: 'Récapitulatif créé',
  regenerateStatements: 'Regénérer des statements',
  downloadListStatements: 'Télécharger les statements de la liste',
  downloadingStatements: 'Téléchargement des statements…',
  downloadingStatements_intro:
    'Lancer le téléchargement de %{count} statements, chacun au format suivant:',
  downloadingStatements_generate: 'Lancer le téléchargement',
  downloadingStatements_description:
    "Vos statements sont actuellement en cours de génération, ils seront prêts d'ici quelques instants.",
  downloadingStatements_success: 'Statements téléchargés',
  downloadingStatements_queued: "En file d'attente...",
  downloadingStatements_generating: 'Génération en cours...',
  netRevenue: 'Revenu Net',
  adjustment: 'Ajustements',
  statementAdjustmentRows: "Lignes d'ajustement",
  addAdjustmentRow: "Ajouter une ligne d'ajustement",
  adjustmentRow: {
    label: 'Label',
    amountInEuros: 'Montant en €',
  },
  created: 'Le statement a été créé',
  regenerated: 'Les statements ont bien été regénérés',
  export: 'Exports',
  pdf: 'PDF',
  csv: 'CSV',
  periodicStatementDownloads: 'Téléchargement de statements par période',
  noStatementCreated: "Veuillez créer un premier statement afin d'accéder à ces rapports",
  monthByMonth: 'Mois par mois',
  videosViews: 'Nombre de vues',
  youtubeGeneratedRevenue: 'Revenus Officiels (en euros)',
  ugcGeneratedRevenue: 'Revenus UGC (en euros)',
  generatedRevenue: 'Revenus (en euros)',
  appliedRate: 'Taux appliqué',
  beneficiaryRevenueInEuros: 'Royautés ayant-droit (en euros)',
  paid: 'Payé',
  notPaid: 'Non payé',
  success: {
    updatedStatus: 'Le statut du statement a bien été mis à jour',
  },
}
